import React from 'react';

const tileStyle = {
  flex: '0 0 auto',
  width: 130,
  padding: '10px 12px',
  background: 'white',
  border: '1px solid #e0e0e0',
  borderRadius: 6,
  borderLeft: '4px solid #ffbe0b',
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
};

const stepNumStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 700,
  fontSize: 10,
  color: '#ffbe0b',
  marginBottom: 4,
  letterSpacing: '0.5px',
};

const stepNameStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 600,
  fontSize: 11,
  color: '#000814',
  lineHeight: 1.35,
};

const arrowStyle = {
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 15,
  color: '#ffbe0b',
  fontSize: 16,
};

/**
 * Side-by-side tiles with arrows showing Tank Process flow.
 */
export default function TankProcessFlow({ steps = [], title = 'Tank Process' }) {
  if (!steps?.length) return null;

  return (
    <div className="quotation-section-block quotation-no-break">
      <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 600, fontSize: 13, color: '#000814', margin: '0 0 12px 0' }}>
        {title}
      </p>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '2px 0',
        }}
      >
        {steps.map((s, i) => (
          <React.Fragment key={i}>
            <div style={{ ...tileStyle, flex: '0 0 auto' }}>
              <div style={stepNumStyle}>Step {i + 1}</div>
              <div style={stepNameStyle}>{s.text}</div>
            </div>
            {i < steps.length - 1 && (
              <div style={arrowStyle} aria-hidden="true">
                →
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
